(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allbetter-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ab-header-shell').forEach((shell) => {
    const header = shell.querySelector('.ab-header');
    if (!header) return;

    const headerGroup = shell.closest('#header-group');
    if (headerGroup) {
      headerGroup.style.position = 'sticky';
      headerGroup.style.top = '0';
      headerGroup.style.zIndex = '1000';
      headerGroup.style.isolation = 'isolate';
    }

    const dropdowns = header.querySelectorAll('.ab-header__dropdown, .ab-locale');

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;

        if (dropdown.classList.contains('ab-header__dropdown')) {
          header.style.setProperty('--ab-mobile-dropdown-top', `${shell.getBoundingClientRect().bottom + 8}px`);
        }

        if (dropdown.classList.contains('ab-locale')) {
          header.style.setProperty('--ab-mobile-locale-top', `${shell.getBoundingClientRect().bottom + 8}px`);
        }

        dropdowns.forEach((otherDropdown) => {
          if (otherDropdown !== dropdown) otherDropdown.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (shell.contains(event.target)) return;
      dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allbetter-product-bundle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ab-bundle-section]').forEach((section) => {
    const quantityInput = section.querySelector('[data-ab-bundle-quantity]');
    const propertyInput = section.querySelector('[data-ab-bundle-property]');
    const radios = section.querySelectorAll('input[type="radio"][data-quantity]');

    const syncBundle = () => {
      const checked = section.querySelector('input[type="radio"][data-quantity]:checked');
      if (!checked) return;
      if (quantityInput) quantityInput.value = checked.dataset.quantity || '1';
      if (propertyInput) propertyInput.value = checked.dataset.title || checked.value || '';
    };

    radios.forEach((radio) => radio.addEventListener('change', syncBundle));
    syncBundle();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allbetter-reviews-newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reviewSections = document.querySelectorAll('.ab-reviews');

    reviewSections.forEach((section) => {
      const track = section.querySelector('.ab-review-track');
      const cards = Array.from(section.querySelectorAll('.ab-review'));
      const dots = Array.from(section.querySelectorAll('.ab-review-dots span'));

      if (!track || cards.length < 2 || dots.length === 0) return;

      let frame = null;

      const setActiveDot = () => {
        frame = null;

        const trackRect = track.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;
        let activeIndex = 0;
        let closestDistance = Infinity;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          const distance = Math.abs(trackCenter - cardCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      };

      const requestActiveDotUpdate = () => {
        if (frame !== null) return;
        frame = window.requestAnimationFrame(setActiveDot);
      };

      track.addEventListener('scroll', requestActiveDotUpdate, { passive: true });
      window.addEventListener('resize', requestActiveDotUpdate);
      setActiveDot();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();
})();
